import React from 'react';

// Local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailCommunicationHistoryWidgetSuccess as MemberDetailCommunicationHistoryWidgetSuccess } from 'ui/views/widgets/memberDetailCommunicationHistoryWidget';
 *
 * // render
 * <MemberDetailCommunicationHistoryWidgetSuccess propName='propValue'/>
 */
export const memberDetailCommunicationHistoryWidgetSuccess = ( props ) => {

    return (
        <div className='ui-member-detail-communication-history-widget'>

            {/* <TabSelectionWidgets tabs = { tabsComp } default={ defaultTab }/> */}

            <WidgetsTabFlow
                tabs={ props.tabs }
                theme='plain'
                requestPayload={ props.requestPayload }
            />
        </div>
    );
};

// set display name
memberDetailCommunicationHistoryWidgetSuccess.displayName = 'memberDetailCommunicationHistoryWidget';

// set default props
memberDetailCommunicationHistoryWidgetSuccess.defaultProps = {
    requestPayload: {},
};

// prop types
memberDetailCommunicationHistoryWidgetSuccess.propTypes = {};


//  *****************************************************

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailCommunicationHistoryWidgetPreloader as MemberDetailCommunicationHistoryWidgetPreloader } from 'ui/views/widgets/memberDetailCommunicationHistoryWidget';
 *
 * // render
 * <MemberDetailCommunicationHistoryWidgetPreloader propName='propValue'/>
 */
export const memberDetailCommunicationHistoryWidgetPreloader = () => {
    return (
        <div className='ui-member-detail-communication-history-widget-preloader'>
           <div className='ui-member-detail-communication-history-widget-preloader__tabList'>
               <div className='ui-member-detail-communication-history-widget-preloader__tabList__tab'></div>
               <div className='ui-member-detail-communication-history-widget-preloader__tabList__tab'></div>
               <div className='ui-member-detail-communication-history-widget-preloader__tabList__tab'></div>
           </div>

           <TableSearchInlineWidgetPreloader
                className='ui-member-detail-communication-history-widget-preloader__table-preloader'
           />
        </div>
    );
};

// set display name
memberDetailCommunicationHistoryWidgetPreloader.displayName = 'memberDetailCommunicationHistoryWidgetPreloader';

// set default props
memberDetailCommunicationHistoryWidgetPreloader.defaultProps = {};

// prop types
memberDetailCommunicationHistoryWidgetPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailCommunicationHistoryWidget as MemberDetailCommunicationHistoryWidget } from 'ui/views/widgets/memberDetailCommunicationHistoryWidget';
 *
 * // render
 * <memberDetailCommunicationHistoryWidget propName='propValue'/>
 */
export const memberDetailCommunicationHistoryWidget = withNetworkState( memberDetailCommunicationHistoryWidgetPreloader, memberDetailCommunicationHistoryWidgetSuccess );
